import { ReactNode } from "react"
import { withViewData } from "../../App/ViewData"
import { DayDataView } from "./DataView"
import { DayViewUI } from "./DayViewUI"
import { DayViewProps } from "./Params"

// The props threaded through both the data-acquisition layer (`DayDataView`) and the
// presentational layer (`DayViewUI`) -- everything `DayView` receives except its own
// `children` slot, which is renamed to `dayChildren` here so it doesn't collide with the
// React `children` that `withViewData` uses to inject `DayViewUI` into the acquisition
// component's child slot.
export interface DayDataProps extends Omit<DayViewProps, "children"> {
  dayChildren?: ReactNode;
}

// `DayDataView` is the `useDeps`/store data-acquisition layer: it builds the
// `DayDataViewData` and provides it via `DayDataContext`, so the presentational
// `DayViewUI` never touches acquisition.
const DayDataViewWithUI = withViewData<DayDataProps>({
  acquire: DayDataView,
  ui: DayViewUI,
});

export function DayView({ children, ...props }: DayViewProps) {
  return <DayDataViewWithUI {...props} dayChildren={children} />;
}
